import { combineReducers } from 'redux';
import app from './app';
import ui from './ui';

const programme = combineReducers({
  app,
  ui,
});

export default programme;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js